import {
  Button,
  Card,
  Container,
  Form,
  InputGroup,
} from "react-bootstrap";
import config from "../../../config/config.json";
import { GoTrash } from "react-icons/go";
import { CiSquarePlus } from "react-icons/ci";
import SocialIconList from "./SocialIconList";
import UseToggle from "../../../Hooks/UseToggle";
import { useState } from "react";

function CreatePageStepOne({
  addUpdatePage,
  saveLoader,
  pageName,
  setPageName,
  pageIdentifier,
  setPageIdentifier,
  heroHeading,
  setHeroHeading,
  heroDescription,
  setHeroDescription,
  socialLinks,
  about,
  setAbout,
  setAboutSection,
  addSocialRow,
  removeSocialRow,
  handleSocialChange,
  hasEmptySocialLinks,
  ICON_MAP,
  handleInputChange
}) {
  const [index, setIndex] = useState(null);
  const toggles = UseToggle();

  return (
    <>
      <Container style={{ maxWidth: 720 }} className="py-4">
        <Card className="border-0 shadow-sm">
          <Card.Body>
            <div className="d-flex justify-content-center mb-2">
              <div
                className="rounded-circle border border-primary text-primary fw-semibold d-flex align-items-center justify-content-center"
                style={{ width: 36, height: 36 }}
              >
                1
              </div>
            </div>
            <div className="text-center mb-3">
              <h4 className="fw-semibold mb-2">Enter Page Details</h4>
              <p className="text-muted mb-0">
                Provide basic information to create your page
              </p>
            </div>
            <Form>
              <Form.Group className="mb-2">
                <Form.Label>Brand Name</Form.Label>
                <Form.Control
                  onChange={handleInputChange(setPageName)}
                  value={pageName}
                  placeholder="Enter Brand name"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>
                  Page Identifier (
                  <Form.Text className="text-muted" style={{ fontSize: 10 }}>
                    This is the unique page URL from
                  </Form.Text>
                  )
                </Form.Label>
                <InputGroup>
                  <InputGroup.Text style={{ fontSize: 12 }}>
                    {config.baseURL}/
                  </InputGroup.Text>
                  <Form.Control
                    onChange={handleInputChange(setPageIdentifier)}
                    value={pageIdentifier}
                    placeholder="Enter page identifier"
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  onChange={handleInputChange(setHeroHeading)}
                  value={heroHeading}
                  placeholder="Enter Heading"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as={`textarea`}
                  rows={2}
                  onChange={handleInputChange(setHeroDescription)}
                  value={heroDescription}
                  placeholder="Enter Description"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Page About</Form.Label>
                <Form.Control
                  as={`textarea`}
                  rows={3}
                  onChange={(e) => {handleInputChange(setAbout); setAboutSection(!!e.target.value)}}
                  value={about}
                  placeholder="Enter Page About"
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <div className="hstack gap-2">
                  <Form.Label>Social Media Links</Form.Label>
                  <CiSquarePlus
                    title="Add More"
                    className="mb-1 text-success CP"
                    onClick={addSocialRow}
                  />
                </div>
                {socialLinks?.map((item, index) => {
                  const IconComponent = ICON_MAP[item.icon];
                  return (
                    <InputGroup key={index} className="mb-2">
                      <Button
                        title={item?.icon}
                        style={{ width: item.icon ? "5%" : "15%", fontSize: 12 }}
                        className="text-nowrap"
                        onClick={() => { toggles.setToggle(); setIndex(index) }}
                      >
                        {IconComponent ? <IconComponent size={16} /> : "Select Icon"}
                      </Button>
                      <Form.Control
                        style={{ width: item.icon ? "25%" : "20%" }}
                        placeholder="Enter Title"
                        value={item.title}
                        onChange={(e) =>
                          handleSocialChange(index, "title", e.target.value)
                        }
                      />
                      <Form.Control
                        style={{ width: item.icon ? "55%" : "50%" }}
                        placeholder="Enter URL"
                        value={item.url}
                        onChange={(e) =>
                          handleSocialChange(index, "url", e.target.value)
                        }
                      />
                      <InputGroup.Text>
                        <GoTrash
                          style={{ fontSize: 15 }}
                          className="text-danger CP"
                          title="Delete"
                          onClick={() => removeSocialRow(index)}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                  );
                })}
              </Form.Group>
            </Form>
          </Card.Body>
          <div className="border-top p-4 d-flex justify-content-end bg-white">
            <Button
              onClick={addUpdatePage}
              // disabled={!about || !pageName || !pageIdentifier || !heroHeading || !heroDescription || saveLoader || hasEmptySocialLinks()}
              variant="primary"
              size="sm"
            >
              Create Page
            </Button>
          </div>
        </Card>
      </Container>
      <SocialIconList
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Select Social Icons`}
        onSelect={(icon, color) => { handleSocialChange(index, "icon", icon); handleSocialChange(index, "color", color); handleSocialChange(index, "title", icon) }}
      />
    </>
  );
}

export default CreatePageStepOne;
